import React from 'react';
import { Select, Spin } from 'antd';
import debounce from 'lodash/debounce';
import { getCouponsList } from '../../modules/Api';
import './couponRemoteSelect.css';

const { Option } = Select;

class CouponRemoteSelect extends React.Component {
  constructor(props) {
    super(props);
    this.lastFetchId = 0;
    this.fetchCoupon = debounce(this.fetchCoupon, 800);
    this.state = {
      data: [],
      value: props.value,
      fetching: false,
    };
    this.init = false;
  }

  fetchCoupon = value => {
    this.lastFetchId += 1;
    const fetchId = this.lastFetchId;
    this.setState({ data: [], fetching: true });

    getCouponsList(`title=${value}&per_page=50`, function(body) {
      if (fetchId !== this.lastFetchId) {
        // for fetch callback order
        return;
      }

      const data = body.data.data.map(coupon => ({
        text: `${coupon.title} - (${coupon.mpn_id})`,
        value: coupon.id,
      }));
      this.setState({ data, fetching: false });
    }.bind(this))
  }

  handleChange = value => {
    this.props.selectChanged(value);
    this.setState({
      value,
      data: [],
      fetching: false,
    });
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.props.value && this.init === false) {
      this.init = true;
      this.setState({ value: nextProps.value });
    }
  }

  render() {
    const { fetching, data, value } = this.state;
    return (
      <Select
        mode="multiple"
        labelInValue
        value={value}
        placeholder="انتخاب قرعه کشیها"
        notFoundContent={fetching ? <Spin size="small" /> : null}
        filterOption={false}
        onSearch={this.fetchCoupon}
        onChange={this.handleChange}
        style={{ width: '100%', direction: 'rtl', textAlign: 'right', float: 'right' }}
      >
        {data.map(d => (
          <Option key={d.value}>{d.text}</Option>
        ))}
      </Select>
    );
  }
}

export default CouponRemoteSelect



// WEBPACK FOOTER //
// ./src/components/Coupon/CouponRemoteSelect.js